<template>
    <div class="content-area__heading">
        <top-nav>
            <div slot="title">
                <h2>Estatísticas</h2>
            </div>
        </top-nav>

        <estatisticas-atendente></estatisticas-atendente>
    </div>
</template>

<script>
    import EstatisticasAtendente from "./components/estatisticas-atendente.vue";
    import TopNav from "../../components/nav-bar/top-nav";
    import TableCsv from "../../components/table-csv/TableCsv";
    
    export default {
        name: "apoio-estatisticas",

        components: {
            EstatisticasAtendente,
            TopNav,
            TableCsv,
        },

        data: () => ({
            estatisicas: {
                bug: {
                    title: "Bug",
                    subtitle: "Tickets",
                    loading: false,
                    refresh: false,
                    download: false,
                    show_download: false,
                    close: false,
                }
            }
        }),
    }
</script>
